// Builds the patient-facing medication string shown in the /me/history
// prescription and shipment tables, e.g.:
//   "Gabapentin 200mg (30 Tablets)"
//   "Propranolol 12mg (30 Raspberry Lemonade Troches)"
//
// The parenthetical combines quantity, an optional flavor, and the (pluralized)
// form factor. Flavor comes from the prescription's `subcategory` — derived
// server-side from the medication NDC, so it's present for every flavored
// compound (PA troches and sleep gummies alike) regardless of order-item links.
// Commercial meds have no flavor subcategory, so it's omitted. When the
// prescription has no form factor we fall back to just "name dosage".

import pluralize from "pluralize";

import { SUBCATEGORY_TO_FLAVOR_DISPLAY } from "~/shared/sharedConstants";

export function medicationLabel(rx) {
  if (!rx) return "";
  const name = [rx.medicationName, rx.medicationDosage]
    .filter(Boolean)
    .join(" ");

  const form = rx.medicationFormFactor;
  if (!form) return name;

  const flavor = SUBCATEGORY_TO_FLAVOR_DISPLAY[rx.subcategory] || "";
  const qty = rx.quantity;

  const parts = [];
  if (qty) parts.push(String(qty));
  if (flavor) parts.push(flavor);
  parts.push(qty ? pluralize(form, qty) : form);

  return `${name} (${parts.join(" ")})`;
}
